import _Accordion from "@material-ui/core/esm/Accordion";
import _AccordionDetails from "@material-ui/core/esm/AccordionDetails";
import _AccordionSummary from "@material-ui/core/esm/AccordionSummary";
import React, { useState, useEffect } from 'react';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import classes from './swag-faq.scss';
export const SwagFAQComponent = ({
  questions
}) => {
  const [expanded, setExpanded] = useState(null);
  useEffect(() => {
    if (questions.length > 0) {
      const speakableData = {
        '@context': 'https://schema.org/',
        '@type': 'WebPage',
        name: 'Category page',
        speakable: {
          '@type': 'SpeakableSpecification',
          cssSelector: ['#faqSection']
        }
      };
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.innerHTML = JSON.stringify(speakableData);
      document.head.appendChild(script);
      return () => {
        document.head.removeChild(script);
      };
    }
  }, [questions.length]);
  const onChange = id => () => {
    setExpanded(expanded === id ? null : id);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, Boolean(questions.length) && /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, "Swag.com FAQ\u2019s"), /*#__PURE__*/React.createElement("div", {
    id: "faqSection",
    className: classes.accordionBlock
  }, questions.map(({
    _id,
    question,
    answer
  }) => /*#__PURE__*/React.createElement(_Accordion, {
    key: _id,
    expanded: expanded === _id,
    onChange: onChange(_id),
    className: classes.accordion
  }, /*#__PURE__*/React.createElement(_AccordionSummary, {
    expandIcon: expanded === _id ? /*#__PURE__*/React.createElement(RemoveIcon, {
      className: classes.icon
    }) : /*#__PURE__*/React.createElement(AddIcon, {
      className: classes.icon
    }),
    className: classes.accordionHeader
  }, question), /*#__PURE__*/React.createElement(_AccordionDetails, {
    className: classes.accordionText
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: answer
    }
  })))))));
};